import { combineReducers } from 'redux';
import GlobalReducer from './global-reducer';
import Page1Reducer from './page1-reducer';
import Page2Reducer from './page2-reducer';
import Page3Reducer from './page3-reducer';
import Page4Reducer from './page4-reducer';

export default combineReducers({
	global: GlobalReducer,
    page1: Page1Reducer,
    page2: Page2Reducer,
    page3: Page3Reducer,
    page4: Page4Reducer,
});